import Ban from './Ban';

export default Ban;
